import { Image, Text, View } from "@react-pdf/renderer";
import { resolveLogoForBrand } from "@src/images/brands.utils";
// eslint-disable-next-line no-restricted-imports
import { format } from "date-fns";
import { type FunctionComponent } from "react";
import { type IntlShape } from "react-intl";

import { styles } from "./PdfHeader.styles";

interface PdfHeaderProps {
    brand: string;
    intl: IntlShape;
}

const PdfHeader: FunctionComponent<PdfHeaderProps> = ({ intl, brand }) => {
    const leftContent =
        brand === "default" ? (
            <View style={styles.logoContainerLeft}>
                <Image src={resolveLogoForBrand(brand)} style={styles.logoImage} />
            </View>
        ) : (
            <View style={styles.titleContainer}>
                <Text style={styles.titleLeft}>{intl.formatMessage({ id: "sparePartsFinder.wishlist.pdf.title", defaultMessage: "Wishlist" })}</Text>
            </View>
        );

    const rightContent =
        brand === "default" ? (
            <View style={styles.titleContainer}>
                <Text style={styles.titleRight}>{intl.formatMessage({ id: "sparePartsFinder.wishlist.pdf.title", defaultMessage: "Wishlist" })}</Text>
            </View>
        ) : (
            <View style={styles.logoContainerRight}>
                <Image src={resolveLogoForBrand(brand)} style={styles.logoImage} />
            </View>
        );

    return (
        <View style={styles.root} fixed={true}>
            <View style={styles.innerContainer}>
                {leftContent}

                <View style={styles.dateTimeContainer}>
                    <Text style={styles.dateTimeText}>{format(new Date(), "M/d/yyyy pp")}</Text>
                </View>

                {rightContent}
            </View>

            <View style={styles.separator} />
        </View>
    );
};

export { PdfHeader };
